


















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
export default {
  name: "FooterIndex",
  computed: {
    ...mapGetters({
      getSiteName: "getSiteName"
    })
  }
}
